import { Component } from '@angular/core';
import { CommunicationService } from './../../shared/services/communication.service';

import { ApiService } from './../../shared/services/api.service';
import { ListBase } from './../../shared/components/base/list/list.base.component';
import { Office } from '../../models/offices/offices.model';

@Component({
  selector: 'swb-office-list',
  templateUrl: './../../shared/components/base/list/list.base.component.html'
})
export class OfficeListComponent extends ListBase<Office> {
  public url = 'offices';
  public routePrefix = 'offices';

  constructor(
    _apiService: ApiService,
    _communicationService: CommunicationService
  ) {
    super(
      _apiService,
      _communicationService
    );
  }


}
